/* eslint-disable no-unused-vars */
/* eslint-disable require-jsdoc */
import React, { forwardRef } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import PropTypes from 'prop-types';
const CalendarComponent = forwardRef((props, ref) => {
  const onChangeDate = (e) => {
    props.setDate(e);
  }
  return (
    <div className="calendar_wrap" ref={ref}>
      <Calendar
        value={props.date}
        onChange={onChangeDate}
        selectRange={true}
        rangeHighlights={true}
        showRangeLabels={true}
      />
    </div>
  );
});
export default CalendarComponent;
// CalendarComponent.propTypes = {
//   date: PropTypes.array,
//   setDate: PropTypes.func,
// };
